// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.12 | MIT License | https://tailwindcss.com */
@layer properties;
.invisible {
  visibility: hidden;
}
.visible {
  visibility: visible;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.static {
  position: static;
}
.sticky {
  position: sticky;
}
.-top-1 {
  top: calc(var(--spacing) * -1);
}
.-top-1\\.5 {
  top: calc(var(--spacing) * -1.5);
}
.-top-\\[0px\\] {
  top: calc(0px * -1);
}
.-top-\\[6px\\] {
  top: calc(6px * -1);
}
.-top-\\[10px\\] {
  top: calc(10px * -1);
}
.top-0 {
  top: calc(var(--spacing) * 0);
}
.top-1\\.5 {
  top: calc(var(--spacing) * 1.5);
}
.top-2 {
  top: calc(var(--spacing) * 2);
}
.top-4 {
  top: calc(var(--spacing) * 4);
}
.top-7 {
  top: calc(var(--spacing) * 7);
}
.top-70 {
  top: calc(var(--spacing) * 70);
}
.top-\\[calc\\(5rem\\+var\\(--popup-tab-height\\,0px\\)\\)\\] {
  top: calc(5rem + var(--popup-tab-height,0px));
}
.top-\\[calc\\(7rem\\+var\\(--popup-tab-height\\,0px\\)\\)\\] {
  top: calc(7rem + var(--popup-tab-height,0px));
}
.-right-1 {
  right: calc(var(--spacing) * -1);
}
.-right-\\[10px\\] {
  right: calc(10px * -1);
}
.right-0 {
  right: calc(var(--spacing) * 0);
}
.right-2 {
  right: calc(var(--spacing) * 2);
}
.right-4 {
  right: calc(var(--spacing) * 4);
}
.-bottom-1\\.5 {
  bottom: calc(var(--spacing) * -1.5);
}
.-bottom-\\[16px\\] {
  bottom: calc(16px * -1);
}
.bottom-0 {
  bottom: calc(var(--spacing) * 0);
}
.bottom-1\\.5 {
  bottom: calc(var(--spacing) * 1.5);
}
.bottom-18 {
  bottom: calc(var(--spacing) * 18);
}
.-left-1\\.5 {
  left: calc(var(--spacing) * -1.5);
}
.left-0 {
  left: calc(var(--spacing) * 0);
}
.left-1\\/2 {
  left: calc(1/2 * 100%);
}
.left-2 {
  left: calc(var(--spacing) * 2);
}
.left-25 {
  left: calc(var(--spacing) * 25);
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.z-999 {
  z-index: 999;
}
.z-\\[999\\] {
  z-index: 999;
}
.container {
  width: 100%;
  @media (width >= 40rem) {
    max-width: 40rem;
  }
  @media (width >= 48rem) {
    max-width: 48rem;
  }
  @media (width >= 64rem) {
    max-width: 64rem;
  }
  @media (width >= 80rem) {
    max-width: 80rem;
  }
  @media (width >= 96rem) {
    max-width: 96rem;
  }
}
.m-0 {
  margin: calc(var(--spacing) * 0);
}
.m-4 {
  margin: calc(var(--spacing) * 4);
}
.mx-1 {
  margin-inline: calc(var(--spacing) * 1);
}
.mx-2 {
  margin-inline: calc(var(--spacing) * 2);
}
.mx-3 {
  margin-inline: calc(var(--spacing) * 3);
}
.mx-4 {
  margin-inline: calc(var(--spacing) * 4);
}
.mx-16 {
  margin-inline: calc(var(--spacing) * 16);
}
.mx-auto {
  margin-inline: auto;
}
.my-2 {
  margin-block: calc(var(--spacing) * 2);
}
.my-3 {
  margin-block: calc(var(--spacing) * 3);
}
.my-4 {
  margin-block: calc(var(--spacing) * 4);
}
.my-5 {
  margin-block: calc(var(--spacing) * 5);
}
.my-6 {
  margin-block: calc(var(--spacing) * 6);
}
.mt-0 {
  margin-top: calc(var(--spacing) * 0);
}
.mt-1 {
  margin-top: calc(var(--spacing) * 1);
}
.mt-2 {
  margin-top: calc(var(--spacing) * 2);
}
.mt-3 {
  margin-top: calc(var(--spacing) * 3);
}
.mt-4 {
  margin-top: calc(var(--spacing) * 4);
}
.mt-5 {
  margin-top: calc(var(--spacing) * 5);
}
.mt-6 {
  margin-top: calc(var(--spacing) * 6);
}
.mt-7 {
  margin-top: calc(var(--spacing) * 7);
}
.mt-8 {
  margin-top: calc(var(--spacing) * 8);
}
.mt-10 {
  margin-top: calc(var(--spacing) * 10);
}
.mt-20 {
  margin-top: calc(var(--spacing) * 20);
}
.mr-1 {
  margin-right: calc(var(--spacing) * 1);
}
.mr-2 {
  margin-right: calc(var(--spacing) * 2);
}
.mr-3 {
  margin-right: calc(var(--spacing) * 3);
}
.mr-4 {
  margin-right: calc(var(--spacing) * 4);
}
.mr-6 {
  margin-right: calc(var(--spacing) * 6);
}
.mb-0\\.5 {
  margin-bottom: calc(var(--spacing) * 0.5);
}
.mb-1 {
  margin-bottom: calc(var(--spacing) * 1);
}
.mb-2 {
  margin-bottom: calc(var(--spacing) * 2);
}
.mb-3 {
  margin-bottom: calc(var(--spacing) * 3);
}
.mb-4 {
  margin-bottom: calc(var(--spacing) * 4);
}
.mb-6 {
  margin-bottom: calc(var(--spacing) * 6);
}
.mb-10 {
  margin-bottom: calc(var(--spacing) * 10);
}
.mb-26 {
  margin-bottom: calc(var(--spacing) * 26);
}
.ml-1 {
  margin-left: calc(var(--spacing) * 1);
}
.ml-2 {
  margin-left: calc(var(--spacing) * 2);
}
.ml-3 {
  margin-left: calc(var(--spacing) * 3);
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.inline {
  display: inline;
}
.inline-block {
  display: inline-block;
}
.table {
  display: table;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: calc(var(--spacing) * 1);
}
.h-3 {
  height: calc(var(--spacing) * 3);
}
.h-4 {
  height: calc(var(--spacing) * 4);
}
.h-5 {
  height: calc(var(--spacing) * 5);
}
.h-6 {
  height: calc(var(--spacing) * 6);
}
.h-8 {
  height: calc(var(--spacing) * 8);
}
.h-9 {
  height: calc(var(--spacing) * 9);
}
.h-10 {
  height: calc(var(--spacing) * 10);
}
.h-12 {
  height: calc(var(--spacing) * 12);
}
.h-14 {
  height: calc(var(--spacing) * 14);
}
.h-16 {
  height: calc(var(--spacing) * 16);
}
.h-17 {
  height: calc(var(--spacing) * 17);
}
.h-18 {
  height: calc(var(--spacing) * 18);
}
.h-19 {
  height: calc(var(--spacing) * 19);
}
.h-20 {
  height: calc(var(--spacing) * 20);
}
.h-24 {
  height: calc(var(--spacing) * 24);
}
.h-26 {
  height: calc(var(--spacing) * 26);
}
.h-50 {
  height: calc(var(--spacing) * 50);
}
.h-100 {
  height: calc(var(--spacing) * 100);
}
.h-140 {
  height: calc(var(--spacing) * 140);
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.max-h-80 {
  max-height: calc(var(--spacing) * 80);
}
.min-h-10 {
  min-height: calc(var(--spacing) * 10);
}
.min-h-12 {
  min-height: calc(var(--spacing) * 12);
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: calc(var(--spacing) * 0);
}
.w-2 {
  width: calc(var(--spacing) * 2);
}
.w-3 {
  width: calc(var(--spacing) * 3);
}
.w-3\\/5 {
  width: calc(3/5 * 100%);
}
.w-4 {
  width: calc(var(--spacing) * 4);
}
.w-4\\/5 {
  width: calc(4/5 * 100%);
}
.w-5 {
  width: calc(var(--spacing) * 5);
}
.w-5\\/7 {
  width: calc(5/7 * 100%);
}
.w-6 {
  width: calc(var(--spacing) * 6);
}
.w-8 {
  width: calc(var(--spacing) * 8);
}
.w-10 {
  width: calc(var(--spacing) * 10);
}
.w-12 {
  width: calc(var(--spacing) * 12);
}
.w-14 {
  width: calc(var(--spacing) * 14);
}
.w-16 {
  width: calc(var(--spacing) * 16);
}
.w-18 {
  width: calc(var(--spacing) * 18);
}
.w-20 {
  width: calc(var(--spacing) * 20);
}
.w-24 {
  width: calc(var(--spacing) * 24);
}
.w-25 {
  width: calc(var(--spacing) * 25);
}
.w-26 {
  width: calc(var(--spacing) * 26);
}
.w-30 {
  width: calc(var(--spacing) * 30);
}
.w-38 {
  width: calc(var(--spacing) * 38);
}
.w-40 {
  width: calc(var(--spacing) * 40);
}
.w-44 {
  width: calc(var(--spacing) * 44);
}
.w-60 {
  width: calc(var(--spacing) * 60);
}
.w-300 {
  width: calc(var(--spacing) * 300);
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-\\[calc\\(100\\%-8rem\\)\\] {
  width: calc(100% - 8rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-15 {
  min-width: calc(var(--spacing) * 15);
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: calc(calc(1/2 * 100%) * -1);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.translate-y-full {
  --tw-translate-y: 100%;
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.-rotate-8 {
  rotate: calc(8deg * -1);
}
.rotate-7 {
  rotate: 7deg;
}
.rotate-10 {
  rotate: 10deg;
}
.transform {
  transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-baseline {
  align-items: baseline;
}
.items-center {
  align-items: center;
}
.items-end {
  align-items: flex-end;
}
.items-start {
  align-items: flex-start;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-start {
  justify-content: flex-start;
}
.gap-0 {
  gap: calc(var(--spacing) * 0);
}
.gap-1 {
  gap: calc(var(--spacing) * 1);
}
.gap-2 {
  gap: calc(var(--spacing) * 2);
}
.gap-2\\.5 {
  gap: calc(var(--spacing) * 2.5);
}
.gap-3 {
  gap: calc(var(--spacing) * 3);
}
.gap-4 {
  gap: calc(var(--spacing) * 4);
}
.space-y-1 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-2 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-3 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-4 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.gap-x-3 {
  -moz-column-gap: calc(var(--spacing) * 3);
       column-gap: calc(var(--spacing) * 3);
}
.gap-x-6 {
  -moz-column-gap: calc(var(--spacing) * 6);
       column-gap: calc(var(--spacing) * 6);
}
.space-x-2 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.space-x-3 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 3) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.space-x-4 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.space-x-6 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 6) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.space-x-10 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 10) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.gap-y-2 {
  row-gap: calc(var(--spacing) * 2);
}
.gap-y-3 {
  row-gap: calc(var(--spacing) * 3);
}
.gap-y-5 {
  row-gap: calc(var(--spacing) * 5);
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: var(--radius-2xl);
}
.rounded-full {
  border-radius: calc(infinity * 1px);
}
.rounded-lg {
  border-radius: var(--radius-lg);
}
.rounded-md {
  border-radius: var(--radius-md);
}
.rounded-xl {
  border-radius: var(--radius-xl);
}
.rounded-t-xl {
  border-top-left-radius: var(--radius-xl);
  border-top-right-radius: var(--radius-xl);
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius-lg);
  border-bottom-left-radius: var(--radius-lg);
}
.border {
  border-style: var(--tw-border-style);
  border-width: 1px;
}
.border-0 {
  border-style: var(--tw-border-style);
  border-width: 0px;
}
.border-2 {
  border-style: var(--tw-border-style);
  border-width: 2px;
}
.border-t {
  border-top-style: var(--tw-border-style);
  border-top-width: 1px;
}
.border-b {
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 0px;
}
.border-l {
  border-left-style: var(--tw-border-style);
  border-left-width: 1px;
}
.border-dashed {
  --tw-border-style: dashed;
  border-style: dashed;
}
.border-none {
  --tw-border-style: none;
  border-style: none;
}
.border-\\[\\#FF9300\\] {
  border-color: #FF9300;
}
.border-gray-100 {
  border-color: var(--color-gray-100);
}
.border-gray-200 {
  border-color: var(--color-gray-200);
}
.border-gray-300 {
  border-color: var(--color-gray-300);
}
.border-orange-500 {
  border-color: var(--color-orange-500);
}
.bg-\\[\\#FFC736\\] {
  background-color: #FFC736;
}
.bg-\\[\\#f7f7f7\\] {
  background-color: #f7f7f7;
}
.bg-\\[\\#f7fafc\\] {
  background-color: #f7fafc;
}
.bg-\\[\\#fff\\] {
  background-color: #fff;
}
.bg-gray-50 {
  background-color: var(--color-gray-50);
}
.bg-gray-100 {
  background-color: var(--color-gray-100);
}
.bg-gray-500 {
  background-color: var(--color-gray-500);
}
.bg-orange-100 {
  background-color: var(--color-orange-100);
}
.bg-orange-300 {
  background-color: var(--color-orange-300);
}
.bg-orange-500 {
  background-color: var(--color-orange-500);
}
.bg-orange-600 {
  background-color: var(--color-orange-600);
}
.bg-red-500 {
  background-color: var(--color-red-500);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  background-color: var(--color-white);
}
.bg-gradient-to-br {
  --tw-gradient-position: to bottom right in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.from-orange-300 {
  --tw-gradient-from: var(--color-orange-300);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-orange-400 {
  --tw-gradient-to: var(--color-orange-400);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0 {
  padding: calc(var(--spacing) * 0);
}
.p-1 {
  padding: calc(var(--spacing) * 1);
}
.p-2 {
  padding: calc(var(--spacing) * 2);
}
.p-3 {
  padding: calc(var(--spacing) * 3);
}
.p-4 {
  padding: calc(var(--spacing) * 4);
}
.p-6 {
  padding: calc(var(--spacing) * 6);
}
.px-0 {
  padding-inline: calc(var(--spacing) * 0);
}
.px-0\\.5 {
  padding-inline: calc(var(--spacing) * 0.5);
}
.px-1 {
  padding-inline: calc(var(--spacing) * 1);
}
.px-1\\.5 {
  padding-inline: calc(var(--spacing) * 1.5);
}
.px-2 {
  padding-inline: calc(var(--spacing) * 2);
}
.px-3 {
  padding-inline: calc(var(--spacing) * 3);
}
.px-4 {
  padding-inline: calc(var(--spacing) * 4);
}
.px-6 {
  padding-inline: calc(var(--spacing) * 6);
}
.py-0 {
  padding-block: calc(var(--spacing) * 0);
}
.py-1 {
  padding-block: calc(var(--spacing) * 1);
}
.py-2 {
  padding-block: calc(var(--spacing) * 2);
}
.py-3 {
  padding-block: calc(var(--spacing) * 3);
}
.py-4 {
  padding-block: calc(var(--spacing) * 4);
}
.py-8 {
  padding-block: calc(var(--spacing) * 8);
}
.pt-1 {
  padding-top: calc(var(--spacing) * 1);
}
.pt-2 {
  padding-top: calc(var(--spacing) * 2);
}
.pt-3 {
  padding-top: calc(var(--spacing) * 3);
}
.pt-4 {
  padding-top: calc(var(--spacing) * 4);
}
.pt-10 {
  padding-top: calc(var(--spacing) * 10);
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pr-0 {
  padding-right: calc(var(--spacing) * 0);
}
.pr-2 {
  padding-right: calc(var(--spacing) * 2);
}
.pr-3 {
  padding-right: calc(var(--spacing) * 3);
}
.pb-0\\.5 {
  padding-bottom: calc(var(--spacing) * 0.5);
}
.pb-1 {
  padding-bottom: calc(var(--spacing) * 1);
}
.pb-2 {
  padding-bottom: calc(var(--spacing) * 2);
}
.pb-3 {
  padding-bottom: calc(var(--spacing) * 3);
}
.pb-4 {
  padding-bottom: calc(var(--spacing) * 4);
}
.pb-10 {
  padding-bottom: calc(var(--spacing) * 10);
}
.pb-14 {
  padding-bottom: calc(var(--spacing) * 14);
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pb-\\[env\\(safe-area-inset-bottom\\)\\] {
  padding-bottom: env(safe-area-inset-bottom);
}
.pl-2 {
  padding-left: calc(var(--spacing) * 2);
}
.pl-3 {
  padding-left: calc(var(--spacing) * 3);
}
.pl-4 {
  padding-left: calc(var(--spacing) * 4);
}
.pl-5 {
  padding-left: calc(var(--spacing) * 5);
}
.pl-6 {
  padding-left: calc(var(--spacing) * 6);
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: var(--text-2xl);
  line-height: var(--tw-leading, var(--text-2xl--line-height));
}
.text-4xl {
  font-size: var(--text-4xl);
  line-height: var(--tw-leading, var(--text-4xl--line-height));
}
.text-base {
  font-size: var(--text-base);
  line-height: var(--tw-leading, var(--text-base--line-height));
}
.text-lg {
  font-size: var(--text-lg);
  line-height: var(--tw-leading, var(--text-lg--line-height));
}
.text-sm {
  font-size: var(--text-sm);
  line-height: var(--tw-leading, var(--text-sm--line-height));
}
.text-xl {
  font-size: var(--text-xl);
  line-height: var(--tw-leading, var(--text-xl--line-height));
}
.text-xs {
  font-size: var(--text-xs);
  line-height: var(--tw-leading, var(--text-xs--line-height));
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.leading-6 {
  --tw-leading: calc(var(--spacing) * 6);
  line-height: calc(var(--spacing) * 6);
}
.leading-10 {
  --tw-leading: calc(var(--spacing) * 10);
  line-height: calc(var(--spacing) * 10);
}
.leading-none {
  --tw-leading: 1;
  line-height: 1;
}
.leading-relaxed {
  --tw-leading: var(--leading-relaxed);
  line-height: var(--leading-relaxed);
}
.font-bold {
  --tw-font-weight: var(--font-weight-bold);
  font-weight: var(--font-weight-bold);
}
.font-medium {
  --tw-font-weight: var(--font-weight-medium);
  font-weight: var(--font-weight-medium);
}
.font-semibold {
  --tw-font-weight: var(--font-weight-semibold);
  font-weight: var(--font-weight-semibold);
}
.text-\\[\\#646566\\] {
  color: #646566;
}
.text-\\[\\#ff7a00\\] {
  color: #ff7a00;
}
.text-blue-500 {
  color: var(--color-blue-500);
}
.text-blue-600 {
  color: var(--color-blue-600);
}
.text-gray-300 {
  color: var(--color-gray-300);
}
.text-gray-400 {
  color: var(--color-gray-400);
}
.text-gray-500 {
  color: var(--color-gray-500);
}
.text-gray-600 {
  color: var(--color-gray-600);
}
.text-gray-700 {
  color: var(--color-gray-700);
}
.text-gray-800 {
  color: var(--color-gray-800);
}
.text-gray-900 {
  color: var(--color-gray-900);
}
.text-green-500 {
  color: var(--color-green-500);
}
.text-orange-500 {
  color: var(--color-orange-500);
}
.text-orange-600 {
  color: var(--color-orange-600);
}
.text-red-500 {
  color: var(--color-red-500);
}
.text-red-600 {
  color: var(--color-red-600);
}
.text-white {
  color: var(--color-white);
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-70 {
  opacity: 70%;
}
.shadow-\\[0_4px_6px_-1px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
  --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgba(0,0,0,0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.outline {
  outline-style: var(--tw-outline-style);
  outline-width: 1px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.filter {
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.transition {
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, visibility, content-visibility, overlay, pointer-events;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-all {
  transition-property: all;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-colors {
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-transform {
  transition-property: transform, translate, scale, rotate;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.duration-200 {
  --tw-duration: 200ms;
  transition-duration: 200ms;
}
.duration-300 {
  --tw-duration: 300ms;
  transition-duration: 300ms;
}
.ease-out {
  --tw-ease: var(--ease-out);
  transition-timing-function: var(--ease-out);
}
.last\\:mb-0 {
  &:last-child {
    margin-bottom: calc(var(--spacing) * 0);
  }
}
.last\\:border-b-0 {
  &:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
}
.hover\\:border-gray-300 {
  &:hover {
    @media (hover: hover) {
      border-color: var(--color-gray-300);
    }
  }
}
.hover\\:bg-gray-50 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-50);
    }
  }
}
.hover\\:bg-gray-100 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-100);
    }
  }
}
.hover\\:bg-gray-200 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-200);
    }
  }
}
.hover\\:bg-orange-200 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-orange-200);
    }
  }
}
.hover\\:bg-orange-600 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-orange-600);
    }
  }
}
.sm\\:top-12 {
  @media (width >= 40rem) {
    top: calc(var(--spacing) * 12);
  }
}
.sm\\:top-\\[calc\\(5rem\\+var\\(--popup-tab-height\\,0px\\)\\)\\] {
  @media (width >= 40rem) {
    top: calc(5rem + var(--popup-tab-height,0px));
  }
}
.sm\\:top-\\[calc\\(7rem\\+var\\(--popup-tab-height\\,0px\\)\\)\\] {
  @media (width >= 40rem) {
    top: calc(7rem + var(--popup-tab-height,0px));
  }
}
.sm\\:mx-26 {
  @media (width >= 40rem) {
    margin-inline: calc(var(--spacing) * 26);
  }
}
.sm\\:mr-0 {
  @media (width >= 40rem) {
    margin-right: calc(var(--spacing) * 0);
  }
}
.sm\\:grid-cols-3 {
  @media (width >= 40rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.sm\\:gap-3 {
  @media (width >= 40rem) {
    gap: calc(var(--spacing) * 3);
  }
}
.md\\:top-13 {
  @media (width >= 48rem) {
    top: calc(var(--spacing) * 13);
  }
}
.md\\:top-\\[calc\\(8rem\\+var\\(--popup-tab-height\\,0px\\)\\)\\] {
  @media (width >= 48rem) {
    top: calc(8rem + var(--popup-tab-height,0px));
  }
}
.md\\:mx-4 {
  @media (width >= 48rem) {
    margin-inline: calc(var(--spacing) * 4);
  }
}
.md\\:mx-40 {
  @media (width >= 48rem) {
    margin-inline: calc(var(--spacing) * 40);
  }
}
.md\\:mt-2 {
  @media (width >= 48rem) {
    margin-top: calc(var(--spacing) * 2);
  }
}
.md\\:mb-0 {
  @media (width >= 48rem) {
    margin-bottom: calc(var(--spacing) * 0);
  }
}
.md\\:block {
  @media (width >= 48rem) {
    display: block;
  }
}
.md\\:flex {
  @media (width >= 48rem) {
    display: flex;
  }
}
.md\\:hidden {
  @media (width >= 48rem) {
    display: none;
  }
}
.md\\:w-2\\/5 {
  @media (width >= 48rem) {
    width: calc(2/5 * 100%);
  }
}
.md\\:w-4\\/5 {
  @media (width >= 48rem) {
    width: calc(4/5 * 100%);
  }
}
.md\\:w-\\[calc\\(100\\%-2rem\\)\\] {
  @media (width >= 48rem) {
    width: calc(100% - 2rem);
  }
}
.md\\:grid-cols-4 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.md\\:grid-cols-5 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.md\\:bg-\\[var\\(--custom-bg\\)\\] {
  @media (width >= 48rem) {
    background-color: var(--custom-bg);
  }
}
.md\\:pt-3 {
  @media (width >= 48rem) {
    padding-top: calc(var(--spacing) * 3);
  }
}
.md\\:text-xs {
  @media (width >= 48rem) {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
}
.lg\\:top-14 {
  @media (width >= 64rem) {
    top: calc(var(--spacing) * 14);
  }
}
.lg\\:mx-4 {
  @media (width >= 64rem) {
    margin-inline: calc(var(--spacing) * 4);
  }
}
.lg\\:mx-52 {
  @media (width >= 64rem) {
    margin-inline: calc(var(--spacing) * 52);
  }
}
.lg\\:w-\\[60\\%\\] {
  @media (width >= 64rem) {
    width: 60%;
  }
}
.lg\\:w-\\[100px\\] {
  @media (width >= 64rem) {
    width: 100px;
  }
}
.lg\\:w-\\[calc\\(100\\%-2rem\\)\\] {
  @media (width >= 64rem) {
    width: calc(100% - 2rem);
  }
}
.lg\\:grid-cols-5 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.xl\\:top-10 {
  @media (width >= 80rem) {
    top: calc(var(--spacing) * 10);
  }
}
.xl\\:mx-76 {
  @media (width >= 80rem) {
    margin-inline: calc(var(--spacing) * 76);
  }
}
.xl\\:grid-cols-6 {
  @media (width >= 80rem) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
.\\32 xl\\:top-10 {
  @media (width >= 96rem) {
    top: calc(var(--spacing) * 10);
  }
}
.\\32 xl\\:mx-92 {
  @media (width >= 96rem) {
    margin-inline: calc(var(--spacing) * 92);
  }
}
.\\32 xl\\:grid-cols-6 {
  @media (width >= 96rem) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
.\\32 xl\\:grid-cols-7 {
  @media (width >= 96rem) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
}
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-orange-100: oklch(95.4% 0.038 75.164);
    --color-orange-200: oklch(90.1% 0.076 70.697);
    --color-orange-300: oklch(83.7% 0.128 66.29);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-orange-600: oklch(64.6% 0.222 41.116);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-white: #fff;
    --spacing: 0.25rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --leading-relaxed: 1.625;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities;
@layer base {
  html {
    font-family: "Varela Round", "Noto Sans SC", sans-serif;
  }
  body {
    font-family: "Varela Round", "Noto Sans SC", sans-serif;
  }
}
html, body, #app {
  height: 100%;
  background-color: #f7fafc;
  font-family: "Varela Round", "Noto Sans SC", sans-serif;
}
.shadow {
  box-shadow: 0 2px 8px rgba(0,0,0,.05);
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
@media (max-width: 63.999999999rem) {
  .container {
    max-width: none !important;
  }
}
@media (max-width: 63.999999999rem) {
  .yoyo-container {
    max-width: none !important;
  }
}
@media (width >= 64rem) {
  .yoyo-container {
    max-width: 64rem;
    margin-inline: auto;
  }
}
@media (width >= 80rem) {
  .yoyo-container {
    max-width: 64rem;
    margin-inline: auto;
  }
}
@media (width >= 96rem) {
  .yoyo-container {
    max-width: 72rem;
    margin-inline: auto;
  }
}
@media (width >= 64rem) {
  .home-container {
    max-width: 64rem;
    margin-inline: auto;
  }
}
@media (width >= 80rem) {
  .home-container {
    max-width: 80rem;
    margin-inline: auto;
  }
}
@media (width >= 96rem) {
  .home-container {
    max-width: 96rem;
    margin-inline: auto;
  }
}
@media (width >= 120rem) {
  .home-container {
    max-width: 120rem;
    margin-inline: auto;
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
